import { FormSteps } from '@pages/auth'
import React, { Dispatch, SetStateAction } from 'react'
import {
  DeepMap,
  FieldError,
  UseFormHandleSubmit,
  UseFormRegister,
} from 'react-hook-form'
import V1AuthFlow from './v1'
import V2AuthFlow from './v2'
import {
  InitiateAuth,
  VerificationCodeFormProps,
} from '@components/VerificationCodeForm'

/** based on authSchema */
export type ContactInfoFields = Partial<{
  emailAddress: string
  phoneNumber: string
  countryCode: string
  acceptTerms: boolean
}>

export type ValidatedContactInfo = Required<
  Omit<ContactInfoFields, 'countryCode'>
>

export type AuthFlowProps = {
  displayAuthenticationRevisedLayout: boolean
  step: FormSteps
  verificationFormData: InitiateAuth

  onSubmitVericiationCode: VerificationCodeFormProps['onSubmitCode']
  otpFailureMessage: string
  setOtpFailureMessage?: Dispatch<SetStateAction<string>>
  isLoading: boolean

  /** sending OTP */
  handleSubmit: UseFormHandleSubmit<ContactInfoFields>
  onSubmit: (formData: ValidatedContactInfo) => void
  register: UseFormRegister<ContactInfoFields>
  errors: DeepMap<ContactInfoFields, FieldError>
  isValid: boolean
}

export default function AuthFlow({
  displayAuthenticationRevisedLayout,
  step,
  verificationFormData,
  onSubmitVericiationCode: onVerificationSubmit,
  otpFailureMessage,
  setOtpFailureMessage,
  isLoading,
  handleSubmit: handleSubmit,
  onSubmit: onSubmitContact,
  register,
  errors,
  isValid,
}: AuthFlowProps) {
  return displayAuthenticationRevisedLayout ? (
    <V2AuthFlow
      step={step}
      verificationFormData={verificationFormData}
      onVerificationSubmit={onVerificationSubmit}
      otpFailureMessage={otpFailureMessage}
      setOtpFailureMessage={setOtpFailureMessage}
      isLoading={isLoading}
      handleSubmit={handleSubmit}
      onSubmitContact={onSubmitContact}
      register={register}
      errors={errors}
      isValid={isValid}
    />
  ) : (
    <V1AuthFlow
      step={step}
      verificationFormData={verificationFormData}
      onVerificationSubmit={onVerificationSubmit}
      otpFailureMessage={otpFailureMessage}
      setOtpFailureMessage={setOtpFailureMessage}
      isLoading={isLoading}
      handleSubmit={handleSubmit}
      onSubmitContact={onSubmitContact}
      register={register}
      errors={errors}
      isValid={isValid}
    />
  )
}
